import { GeneralStatusEnum } from '../common/enums/common.enum';
import React from 'react';
import { Box, Switch, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface GenericStatusSwitchProps {
  status: GeneralStatusEnum;
  onChange: (newStatus: GeneralStatusEnum) => void;
  label?: string;
  showStatusText?: boolean;
  disabled?: boolean;
}

const GenericStatusSwitch: React.FC<GenericStatusSwitchProps> = ({ label, status, onChange, showStatusText = true, disabled }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const handleToggle = () => {
    onChange(status === GeneralStatusEnum.ACTIVE ? GeneralStatusEnum.INACTIVE : GeneralStatusEnum.ACTIVE);
  };

  return (
    <Box>
      {label && (
        <Typography
          sx={{
            color: theme.palette.text.secondary,
            fontFamily: theme.typography.fontFamily,
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
            mb: '8px'
          }}
        >
          {label}
        </Typography>
      )}

      <Box
        sx={{
          display: 'flex',
          width: 'auto',
          alignItems: 'center',
          gap: '13px'
        }}
      >
        <Switch checked={status === GeneralStatusEnum.ACTIVE} onChange={handleToggle} size="small" color="primary" disabled={disabled} />
        {showStatusText && (
          <Typography
            variant="body2"
            sx={{
              color: status === GeneralStatusEnum.ACTIVE ? theme.palette.text.primary : theme.palette.text.secondary
            }}
          >
            {/* the enum value is the backend's word for it; what the admin reads is translated */}
            {t(`enums.generalStatus.${status}`)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
export default GenericStatusSwitch;
